import Icon from '../components/Icon.vue'

Icon.register({"screwdriver":{"width":512,"height":512,"paths":[{"d":"M448 0L320 96V158.1L237 241.1C243.8 245.3 250.2 250.2 256 256 261.8 261.8 266.7 268.2 270.9 275L353.9 192H416L512 64 448 0zM128 278.6L10.9 395.7C-3.6 410.2-3.6 433.8 10.9 448.4L63.6 501.1C78.2 515.6 101.8 515.6 116.3 501.1L233.4 384C262.5 354.9 262.5 307.7 233.4 278.6S157.1 249.5 128 278.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/screwdriver.js
// module id = null
// module chunks = 